/*
 * Mobile nav
 *
 */

'use-strict';

import 'wicg-inert';

class MainNav {
  constructor() {
    this.ESCAPE_CODE = 27;
    this.SPACE_CODE = 32;
    this.BREAKPOINT = 'lg';
    this.ACTIVE_CLASS = 'active';

    this.mainNavLinks = document.querySelectorAll('.js-main-nav-link');
    this.mainNavPanels = [];

    // We convert this to an Array because IE11 doesn't support iterating through a
    // NodeList using .forEach()
    [...this.mainNavLinks].forEach((mainNavLink) => {
      // If this is NOT the last element in its parent,
      // it's followed by a nav panel — add event listeners
      if (mainNavLink.nextElementSibling !== null) {
        mainNavLink.addEventListener(
          'click',
          this.handleMainNavPanelClick.bind(this)
        );
        mainNavLink.addEventListener(
          'keydown',
          this.handleMainNavLinkKeydown.bind(this)
        );
        mainNavLink.setAttribute('role', 'button');
        mainNavLink.setAttribute('aria-expanded', false);
        this.mainNavPanels.push(mainNavLink.nextElementSibling);
      }
    });

    [...this.mainNavPanels].forEach((mainNavPanel) => {
      mainNavPanel.addEventListener(
        'keydown',
        this.handleMainNavPanelKeydown.bind(this)
      );
    });

    // Detect all clicks on the document
    document.addEventListener('click', (event) => {
      // If user clicks inside the element, do nothing
      if (
        event.target.closest('.js-main-nav-link') ||
        event.target.closest('.js-main-nav-panel')
      ) {
        return;
      }

      // If user clicks outside the element, hide it!
      this.togglePanelDisplay();
    });
  }

  togglePanelDisplay(
    mainNavLink = null,
    mainNavPanel = null,
    action = 'toggle'
  ) {
    if (mainNavLink === null || mainNavPanel === null) {
      mainNavLink = document.querySelector('.js-main-nav-link.active');
      mainNavPanel = document.querySelector(
        '.js-main-nav-link.active + .js-main-nav-panel'
      );
    }

    // If still null, return
    if (mainNavLink === null || mainNavPanel === null) {
      return;
    }

    // If panel is active, or the action type is 'close', close it
    if (mainNavPanel.inert === false || action === 'close') {
      // Close all other links
      [...this.mainNavLinks].forEach((mainNavLink) => {
        mainNavLink.classList.remove(this.ACTIVE_CLASS);
        mainNavLink.setAttribute('aria-expanded', false);
        if (mainNavLink.nextElementSibling !== null) {
          mainNavLink.nextElementSibling.inert = true;
        }
      });
      mainNavLink.focus();
    } else {
      // Hide all other links
      [...this.mainNavLinks].forEach((mainNavLink) => {
        mainNavLink.classList.remove(this.ACTIVE_CLASS);
        mainNavLink.setAttribute('aria-expanded', false);
        if (mainNavLink.nextElementSibling !== null) {
          mainNavLink.nextElementSibling.inert = true;
        }
      });
      // Open this panel
      mainNavLink.classList.add(this.ACTIVE_CLASS);
      mainNavLink.setAttribute('aria-expanded', true);
      mainNavPanel.inert = false;
    }
  }

  handleMainNavPanelClick(event) {
    event.preventDefault();
    const mainNavLink = event.currentTarget;
    const mainNavPanel = mainNavLink.nextElementSibling;
    this.togglePanelDisplay(mainNavLink, mainNavPanel);
  }

  // If the user presses the escape key, close the nav panel
  handleMainNavLinkKeydown(event) {
    // Escape key
    if (event.keyCode === this.ESCAPE_CODE) {
      event.preventDefault();
      const mainNavLink = event.currentTarget;
      const mainNavPanel = mainNavLink.nextElementSibling;
      this.togglePanelDisplay(mainNavLink, mainNavPanel, 'close');
    }
    // Spacebar
    if (event.keyCode === this.SPACE_CODE) {
      event.preventDefault();
      const mainNavLink = event.currentTarget;
      const mainNavPanel = mainNavLink.nextElementSibling;
      this.togglePanelDisplay(mainNavLink, mainNavPanel);
    }
  }

  // If the user presses the escape key, close the nav panel and focus on the open button
  handleMainNavPanelKeydown(event) {
    if (event.keyCode === this.ESCAPE_CODE) {
      const mainNavPanel = event.currentTarget;
      const mainNavLink = mainNavPanel.previousElementSibling;
      this.togglePanelDisplay(mainNavLink, mainNavPanel, 'close');
    }
  }
}

export default MainNav;
